import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import HomePage from "@/pages/HomePage";
import CasePage from "@/pages/CasePage";
import FilePage from "@/pages/FilePage";
import PricingPage from "@/pages/PricingPage";
import PaySuccess from "@/pages/PaySuccess";
import PayCancel from "@/pages/PayCancel";
import MyCasesPage from "@/pages/MyCasesPage";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/lib/AuthContext";
// Side-effect: install axios interceptors that attach JWT
import "@/lib/auth";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/file" element={<FilePage />} />
            <Route path="/case/:id" element={<CasePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/pay/success" element={<PaySuccess />} />
            <Route path="/pay/cancel" element={<PayCancel />} />
            <Route path="/my-cases" element={<MyCasesPage />} />
            {/* Legacy: archive is now private. Redirect to My Cases. */}
            <Route path="/archive" element={<Navigate to="/my-cases" replace />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Layout>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              border: "4px solid #0A0A0A",
              borderRadius: "14px",
              background: "#FFE600",
              color: "#0A0A0A",
              fontFamily: "'IBM Plex Mono', monospace",
              boxShadow: "6px 6px 0 0 #0A0A0A",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
